// ФАЙЛ: useZoneSlot.ts
// НАЗНАЧЕНИЕ: Хук регистрации виджета в зоне. Возвращает DOM-узел слота,
// в который виджет порталит своё содержимое (createPortal). Регистрирует
// слот на mount/изменение параметров, снимает регистрацию на unmount.

// @ts-ignore — React берётся из окружения overlay-приложения.
import { useEffect, useState } from 'react'
import { useZoneLayoutContext } from './ZoneLayoutContext'
import type { ZoneSlotOptions } from './types'

/**
 * Регистрирует слот и возвращает его DOM-узел (или null, если провайдер зон
 * не смонтирован — тогда вызывающий рендерит виджет как есть, без портала).
 */
export function useZoneSlot(opts: ZoneSlotOptions): HTMLDivElement | null {
  const ctx = useZoneLayoutContext()
  const [node, setNode] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!ctx) {
      setNode(null)
      return
    }
    const slotNode = ctx.registerSlot(opts)
    setNode(slotNode)
    return () => {
      ctx.unregisterSlot(opts.widgetId)
    }
  }, [ctx, opts.widgetId, opts.zone, opts.priority])

  return node
}
